{"FE_URL":"https://fe-dev.eliso.fsf.tools","FE_API_BASE":"https://api-dev.eliso.fsf.tools"}